export const InstrumentViewTypeEnum = ['Master', 'General'];
